module.exports = "/assets/images/icon-plus.svg?7ec746399be4753f9edfa8c9e3617a4f";